import * as React from 'react';
import { History } from 'history';
import { FormattedHTMLMessage, FormattedMessage, InjectedIntlProps, injectIntl, defineMessages } from 'react-intl';
import * as databaseCategories from '../../../data/db-categories.js';
import CreateSection from './CreateSection';

export interface IState {
    category: string;
    name: string;
    link: string | null;
    isPublic: boolean | null;
    categories: string[];
    validDatabaseLink: boolean | null;
    validTitle: boolean | null;
    validCategory: boolean | null;
}
interface IProps {
    handleSave: (state: IState) => void;
    handleCancel: () => void;
    handleClearSession: boolean | (() => void);
    getSavedSession: () => Promise<{ general: IState } | null>;
    history: History;
    renderNextStepLink: (onClick: () => boolean) => any;
}
const customTypeModalId = 'customTypeModal';

const isValidLink = (link: string): boolean => !!(new RegExp('^(https?:\\/\\/)?' +
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
    '((\\d{1,3}\\.){3}\\d{1,3}))' +
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
    '(\\?[;&a-z\\d%_.~+=-]*)?' +
    '(\\#[-a-z\\d_]*)?$', 'i')).test(link)

class General extends React.Component<IProps & InjectedIntlProps, IState> {
    state = {
        category: '',
        name: '',
        link: null,
        isPublic: null,
        categories: databaseCategories,
        validDatabaseLink: null,
        validTitle: null,
        validCategory: null
    };

    // TODO these should come from backend

    messages = defineMessages({
        dbName: {
            id: 'db.general.name.placeholder',
            defaultMessage: 'Database Name'
        },
        link: {
            id: 'db.general.link.placeholder',
            defaultMessage: 'Enter the web address'
        }
    });

    async componentDidMount() {
        const session = await this.props.getSavedSession();
        if (session && session.general) {
            this.setState({ ...session.general });
        }
    };

    handleAddType = (type: string) => {
        return new Promise<void>((resolve: () => void) => {
            this.setState({ categories: [...this.state.categories, type], category: type }, resolve);
        });
    };

    handleInputChange = (event: any) => {
        window.onbeforeunload = () => {
            return true;
        };
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if (name === 'link') {
            value = value || null
        }
        if (name === 'link' && this.state.validDatabaseLink !== null) this.setState({ validDatabaseLink: value == null ? null : isValidLink(value) });
        else if (name === 'name' && this.state.validTitle !== null) this.setState({ validTitle: !!value });
        else if (name === 'category' && this.state.validCategory !== null) this.setState({ validCategory: !!value });
        /* tslint:disable */
        // @ts-ignore
        if (name === 'category' && value === 'other') $(`#${customTypeModalId}`).modal('show')
        const x = {};
        x[name] = value;
        this.setState(x);
        /* tslint:enable */
    };

    handleBooleanInputChange = (event: any) => {
        window.onbeforeunload = () => {
            return true;
        };
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if (value === 'yes') value = true;
        else if (value === 'no') value = false;
        else value = null;
        /* tslint:disable */
        const x = {};
        x[name] = value;
        this.setState(x);
        /* tslint:enable */
    };

    validateState = (): boolean => {
        const { category, name, link } = this.state;
        return !!(category && name && (!link || isValidLink(link || '')));
    };

    handleSave = (): boolean => {
        if (this.validateState()) {
            this.props.handleSave({ ...this.state, validDatabaseLink: true, validTitle: true, validCategory: true });
            return true;
        } else {
            this.setState({ validDatabaseLink: this.state.link ? isValidLink(this.state.link || '') : null, validTitle: !!this.state.name, validCategory: !!this.state.category })
            return false;
        }
    };

    render() {
        return (
            <div>
                <div className="row px-2">
                    <h5><FormattedMessage id="db.general.hello" defaultMessage="Hello!" /></h5>
                </div>
                <div className="row text-muted px-2 py-3">
                    <FormattedHTMLMessage id="db.general.intro" defaultMessage={`
                    <p>Welcome to your new Harmonize® database!</p>
                    <p>This step-by-step process will lead you through customizing your database
                    to ensure that you, your partners, and your end users get the maximum benefit.</p>
                    <p>Help and recommendations are provided along the way.
                    Your progress is also automatically saved as you go, so you can come back to finish at a later time.</p>
                    `} />
                </div>
                <div className="row px-2 py-3 border-bottom">
                    <h5><FormattedMessage id="db.general.hdr" defaultMessage="1. General Info" /></h5>
                </div>
                <div className="row">
                    <div className="col-4">
                        <div className="form-group">
                            <label className="text-muted" htmlFor="category">
                                <FormattedMessage id="db.general.category" defaultMessage="Database Category" />
                            </label>
                            <select
                                className={`form-control custom-select ${this.state.validCategory === false
                                    ? 'is-invalid'
                                    : ''
                                    }`}
                                name="category"
                                onChange={this.handleInputChange}
                                value={this.state.category}>
                                <option key="dbCatNil" value="" />
                                <FormattedMessage id="db.general.type.add.btn" defaultMessage="Other">
                                    {(txt: string) => (<option value="other">{txt}</option>)}
                                </FormattedMessage>
                                {this.state.categories.map((opt) =>
                                    <option value={opt} key={opt + (Math.random())}>{opt}</option>
                                )
                                }
                            </select>
                            <div className="invalid-feedback">
                                <FormattedMessage id="db.general.category.req" defaultMessage="Please select the category of this database." />
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <span className="align-middle d-inline-block mt-4">
                            <FormattedMessage id="db.general.category.help" defaultMessage="If you do not see an option that fits, you may add a custom category.">
                                {(txt) => (<small className="text-muted text-small">{txt}</small>)}
                            </FormattedMessage>
                            <br />
                            <button
                                data-toggle="modal"
                                data-target={`#${customTypeModalId}`}
                                className="btn btn-link small"
                                style={{ padding: 0 }}>
                                <FormattedMessage id="db.general.category.add.btn" defaultMessage="Add Custom Category" />
                            </button>
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <div className="form-group">
                            <label className="text-muted" htmlFor="name">
                                <FormattedMessage id="db.general.title" defaultMessage="Database Title" />
                            </label>
                            <input
                                className={`form-control ${this.state.validTitle === false
                                    ? 'is-invalid'
                                    : ''
                                    }`}
                                type="text"
                                autoComplete="off"
                                placeholder={this.props.intl.formatMessage(this.messages.dbName)}
                                value={this.state.name}
                                name="name"
                                onChange={this.handleInputChange}
                            />
                            <div className="invalid-feedback">
                                <FormattedMessage id="db.general.title.req" defaultMessage="Please give your database a name." />
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <span className="align-middle d-inline-block mt-4">
                            <FormattedMessage id="db.general.name.help" defaultMessage="E.g. County Resource Database">
                                {(txt) => (<small className="text-muted text-small">{txt}</small>)}
                            </FormattedMessage>
                        </span>

                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <div className="form-group">
                            <label className="text-muted" htmlFor="link">
                                <FormattedMessage id="db.general.link" defaultMessage="Database Link" />
                            </label>
                            {/* TODO what is this actually? */}
                            <input
                                className={`form-control ${this.state.validDatabaseLink === false
                                    ? 'is-invalid'
                                    : ''
                                    }`}
                                name="link"
                                autoComplete="off"
                                value={this.state.link || ''}
                                onChange={this.handleInputChange}
                                type="text"
                                placeholder={this.props.intl.formatMessage(this.messages.link)}
                            />
                            <div className="invalid-feedback">
                                <FormattedMessage id="db.general.link.req" defaultMessage="Please provide the link to your database." />
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <span className="align-middle d-inline-block mt-4">
                            <FormattedMessage id="db.general.link.help" defaultMessage="E.g. www.my-organization.com/resourcedirectory">
                                {(txt) => (<small className="text-muted text-small">{txt}</small>)}
                            </FormattedMessage>
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="form-group">
                            <div className="text-muted"><FormattedMessage id="db.general.access" defaultMessage="End User Access" /></div>
                            <div className="form-check">
                                <input
                                    autoComplete="off"
                                    className="form-check-input"
                                    name="isPublic"
                                    type="radio"
                                    id="public-access"
                                    value="yes"
                                    onChange={this.handleBooleanInputChange}
                                    checked={!!this.state.isPublic}
                                />
                                <label className="form-check-label" htmlFor="public-access">
                                    <strong><FormattedMessage id="db.general.access.public" defaultMessage="Public Access" /></strong> / <FormattedMessage id="db.general.access.public.desc" defaultMessage="Open to the public" />
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    autoComplete="off"
                                    className="form-check-input"
                                    id="private-access"
                                    name="isPublic"
                                    type="radio"
                                    value="no"
                                    onChange={this.handleBooleanInputChange}
                                    checked={!this.state.isPublic}
                                />
                                <label className="form-check-label" htmlFor="private-access">
                                    <strong><FormattedMessage id="db.general.access.private" defaultMessage="Private Access" /></strong> / <FormattedMessage id="db.general.access.private.desc" defaultMessage="Requires login to Harmonize®" />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row border-top mt-5">
                    {this.props.renderNextStepLink(this.handleSave)}
                    <button className="btn btn-link" onClick={this.props.handleCancel}><FormattedMessage id="db.general.cancel.btn" defaultMessage="Cancel" /></button>
                    {typeof this.props.handleClearSession === 'function' && <button className="btn btn-link" onClick={this.props.handleClearSession}><FormattedMessage id="db.general.clear.btn" defaultMessage="Clear Session" /></button>}
                </div>

                <FormattedMessage id="db.create.database.type.modal.hdr" defaultMessage="Add Custom Database Category">
                    {(txt: string) => (<CreateSection title={txt} modalId={customTypeModalId} onSave={this.handleAddType} />)}
                </FormattedMessage>
            </div>
        );
    }
}
export default injectIntl(General);


// WEBPACK FOOTER //
// ./src/client/database/setup/General.tsx